<template>
  <div id="menber_favorite" class="menber_control menber_nav padding-30">
    <div class="h_title m-b-15">
      <ul>
        <li class="order_cate_0 active_bg">
          <a href="javascript:;" :style="'color:' + $store.state.color ">
            商品收藏<span v-if="count">({{count}})</span>
            <em :style="'background:' + $store.state.color"></em>
          </a>
        </li>
      </ul>
    </div>
    <div class="b_cont member_table">
      <div class="order_list order_0 active_bg">
        <table class="table">
           <thead>
              <tr>
                 <th>商品图片</th>
                 <th>商品名称</th>
                 <th>商品价格</th>
                 <th>操作</th>
              </tr>
           </thead>
           <tbody>
              <tr v-for="item in list">
                 <td>
                   <a :href="item.url" class="productImage btn-url" target="_blank">
                     <img :src="'http://img.jihui88.com/'+item.product.picPath" width="100" height="100" alt="商品综合测试">
                   </a>
                 </td>
                 <td>
                   <a :href="item.url" class="btn-url" target="_blank">{{item.product.name}}</a>
                 </td>
                 <td>{{item.product.price}}</td>
                 <td><a href="#" @click="del(item.id)">删除</a> </td>
              </tr>
           </tbody>
        </table>
        <div v-if="count>0">
          <Pagination :page="page" :pageSize="pageSize" :count="count" @change-page="changePage"/>
        </div>
        <div v-if="list.length===0" style="text-align: left;padding:10px;color: #999;">
          {{text}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination
  },
  data () {
    return {
      // 数据
      list: [],
      count: 0,
      page: 1,
      pageSize: 3,
      text: '加载中...'
    }
  },
  created () {
    this.get()
  },
  methods: {
    get () {
      var ctx = this
      window.$.ajax({
        url: '/rest/api/shop/favorite/list?page=' + this.page + '&pageSize=' + this.pageSize,
        success (res) {
          if (res.success) {
            var data = res.attributes.data
            ctx.list = data
            ctx.count = res.attributes.count
            if (ctx.list.length === 0) {
              ctx.text = '暂无数据'
            } else {
              ctx.text = '加载中...'
            }
          }
        }
      })
    },
    changePage (page) {
      this.page = page
      this.get()
    },
    // 删除信息
    del (id) {
      var ctx = this
      window.confirm('确认是否删除?', '', function (isConfirm) {
        if (isConfirm) {
          alert('删除成功！', '', function () {}, {type: 'success'})
          ctx.list.forEach((item, index, arr) => {
            if (item.id === id) {
              arr.splice(index, 1)
            }
          })
          window.$.ajax({
            url: '/rest/api/shop/favorite/detail/' + id,
            method: 'post',
            data: {
              _method: 'DELETE'
            },
            success: function (res) {
              if (res.success) {
                ctx.count = ctx.count - 1
                console.log('delete address success')
              }
            }
          })
        } else {
          alert('取消删除！', '', function () {}, {type: 'success'})
        }
      }, {confirmButtonText: '确认', cancelButtonText: '取消!', width: 300})
    }
  }
}
</script>

<style lang="css">
.member_table .btn-url{
    color: #656d77;
}
.member_table .table td{
  vertical-align: middle;
}
.member_table th {
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Favorite.vue